import React, { useState, useMemo, useEffect } from "react";
import AppRoutes from "./AppRoutes";
import { LinkContainer } from "react-router-bootstrap";
import { Nav, Navbar, NavItem, NavDropdown, Button, Toast, Badge } from "react-bootstrap";
import { AppContext } from "./libs/contextLib";
import { useNavigate } from "react-router-dom";
import axiosInstance from "./axiosApi";
import LangDropdown from "./components/LangDropdown";
import { getToken, onMessageListener, defaultPayload, Payload } from "./firebase";
import axios from 'axios'
import { useTranslation } from 'react-i18next';
import config from "./config";
import { differenceInMinutes } from "date-fns";
import { menuStructure } from './data/menuStructure';

function App() {
    
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAuthenticated, userHasAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const history = useNavigate();
  const [options, setOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const { t, i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState('en');
  const [currentLocation, setCurrentLocation] = useState('/');
  const [selectedItemAppContext, setSelectedItemAppContext] = useState('');
  
  const providerValue = useMemo(() => ({
        isAuthenticated, userHasAuthenticated,
        user, setUser,
        currentLocation, setCurrentLocation,
        selectedItemAppContext, setSelectedItemAppContext,
  }), [isAuthenticated, user, currentLocation, selectedItemAppContext]);
  
  const [show, setShow] = useState(false);
  const [notification, setNotification] = useState({title: '', body: ''});
  const [isTokenFound, setTokenFound] = useState(false);
  const [payload, setPayload] = useState(null);
  const [lapseMin, setLapseMin] = useState("");
  const [alarmCount, setAlarmCount] = useState(0);
  const [messageStore, setMessageStore] = useState([]);

  getToken(setTokenFound);

  onMessageListener().then(payload => {
    if (user !== null) {
      setShow(true);
    } else {
      setShow(false);
    }
    setNotification({ title: payload.notification.title, body: payload.notification.body })
    setPayload(payload);
    setLapseMin("just now");
    //console.log(payload);
  }).catch(err => console.log('failed: ', err));

   useEffect(() => {
    const timeout = setTimeout(() => getMessageStore(), 10000);
    return () => clearTimeout(timeout);
  }, [messageStore]);

  function getMessageStore() {  
    try {
      if (isAuthenticated) {
        axiosInstance.get('/CO/messagestorecheck/').then(function(response) {
          //console.log(response.data.length);
          if (typeof response !== 'undefined') {
            setMessageStore(response.data);
            if (isAuthenticated) {
              setAlarmCount(response.data.length)
            } else {
              setAlarmCount(0)
            }    
          }
        }).catch(function (error) {
          setAlarmCount(0)
          console.log(error);
        });
      }
    } catch (error) {
      //onError(error);
    }
  }
  
  useEffect(() => {
    onLoad();
  }, []);

  async function onLoad() {
    axios.post(`${config.DJANGO_URL}/accounts/token/verify/`, {
                token: localStorage.getItem("access_token"),
    }).then(function(response) {
        userHasAuthenticated(true);
        setUser(JSON.parse(localStorage.getItem("access_user")||''));
    }).catch(function (error) {
        //console.log(error);
    });
    setIsAuthenticating(false);
  }
  
  function handleLogout() {
    // add sign out login...
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('access_user');
    userHasAuthenticated(false);
    setUser(null);
    history("/login");
  }
  
  const onChange = (event) => {
    //console.log(event);
    setSelectedValue(event.target.value );
  }
  
  const handleSelect = (eventKey) => {
    if (eventKey === 'en' || eventKey === 'kr') {
      //console.log('A key was pressed', eventKey);
      setSelectedLang(eventKey);
      i18n.changeLanguage(eventKey);
    }
  }
  
  const onClickToast = () => {
      if (user !== null) {
        setShow(true);
      } else {
        setShow(false);
      }
      
      if (payload !== null) {
        setLapseMin(differenceInMinutes(new Date(), new Date(payload.data.crtdate)).toString());
      }
  }
  
  return (
    <>
    { !isAuthenticating && (
    <div>
      <AppContext.Provider value={providerValue}>
        <div className="App">
          <AppRoutes />
        </div>
      </AppContext.Provider>
    </div>
   )
   }</>
  );
}

export default App;

